module.exports = __webpack_public_path__ + "img/title_bg.9c10b676.png";